export const AUTH_CONSTANTS = {
  // Left panel hero
  HERO: {
    COMPANY_ALT: 'Cantaloupe',
    BODY_TEXT:
      'Accept digital payments, engage consumers, and automate decisions — all from one platform.',
    ANIMATION_SEQUENCE: [
      'vending.',
      'micro markets.',
      'self-service.',
      'smart coolers.',
    ],
    COPYRIGHT_PREFIX: '© ',
    COPYRIGHT_SUFFIX: ' Cantaloupe, Inc.',
    COPYRIGHT_VERSION_SEPARATOR: ' · ',
  },

  // Feature chip labels
  FEATURES: {
    REALTIME_VDI: 'Real-time VDI sync',
    SECURE_ACCESS: 'Secure role-based access',
    MULTI_OPERATOR: 'Multi-operator management',
  },

  // Right panel card
  CARD: {
    WELCOME: 'Welcome',
    WELCOME_ACCENT: 'back',
    SUBTITLE: 'Sign in to your Gateway account',
    SIGN_IN_BUTTON: 'Sign in with Auth0',
    FOOTER_PREFIX: 'Secured by',
    FOOTER_BRAND: 'Auth0',
    FOOTER_SUFFIX: '· Single Sign-On enabled',
  },
};
